import React from "react";
import { DataTable, FilterBar, Page, SearchBar, hasActiveFilters, useFilterSortPagination, } from "@sscs/ui";
import IssueDetails from "./IssueDetails";
import { filterTamperingIssues, sortTamperingIssues, } from "./utils";
const initFilter = { search: "" };
const defaultSort = { property: "files", reverse: true };
const initPagination = { currentPage: 1, itemsPerPage: 10 };
const TamperingIssues = ({ issues, idPrefix, }) => {
    const { filter, sort, pagination, handleFilterChange, handleSortChange, handlePaginationChange, } = useFilterSortPagination(initFilter, defaultSort, initPagination);
    const filteredIssues = filterTamperingIssues(issues, filter);
    const sortedIssues = sortTamperingIssues(filteredIssues, sort);
    const pageIssues = sortedIssues.slice((pagination.currentPage - 1) * pagination.itemsPerPage, pagination.currentPage * pagination.itemsPerPage);
    const columns = [
        { id: "expand", label: "", width: "48px" },
        {
            id: "id",
            label: "ID",
            sortProperty: "id",
            sortId: `${idPrefix}-sort-id`,
            width: "110px",
        },
        { id: "description", label: "Description", width: "100%" },
        { id: "enabled", label: "Enabled", width: "90px" },
        { id: "priority", label: "Priority", width: "100px" },
        { id: "cicd", label: "CI/CD", width: "120px" },
        {
            id: "files",
            label: "# Files",
            sortProperty: "files",
            sortId: `${idPrefix}-sort-files`,
            startReverse: true,
            align: "right",
            width: "110px",
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(Page.Filters, { found: {
                id: `${idPrefix}-clear-all-filters`,
                count: filteredIssues.length,
                initialFilters: initFilter,
                activeFilters: filter,
                onClear: () => handleFilterChange(initFilter),
            } },
            React.createElement(FilterBar, { filters: [
                    {
                        id: "search",
                        minWidth: "280px",
                        control: (React.createElement(SearchBar, { id: `${idPrefix}-search`, value: filter.search, onChange: (value) => handleFilterChange({ ...filter, search: value }), label: "Search by rule ID or description", slotProps: { htmlInput: { maxLength: 256 } } })),
                    },
                ] })),
        React.createElement(Page.Body, null,
            React.createElement(DataTable, { key: `${JSON.stringify(filter)} ${JSON.stringify(sort)} ${JSON.stringify(pagination)}`, columns: columns, sort: sort, onSortChange: handleSortChange, empty: {
                    subject: "issues",
                    filters: {
                        active: hasActiveFilters(initFilter, filter),
                        onReset: () => handleFilterChange(initFilter),
                    },
                }, pagination: {
                    id: `${idPrefix}-pagination`,
                    itemCount: filteredIssues.length,
                    pagination,
                    onChange: handlePaginationChange,
                } }, pageIssues.map((issue) => (React.createElement(IssueDetails, { issue: issue, key: issue.id })))))));
};
export default TamperingIssues;
//# sourceMappingURL=TamperingIssues.js.map